export default {
  index: {
    title: '请选择存款方式',
    tip: '请选择存款方式并按照以下流程上传存款凭证',
    sub_title: '不支持第三方存款',
    online_bank_deposit: '网上银行转账',
    atm_transfer_deposit: 'ATM 转账',
    bank_transfer_deposit: '银行柜台转账',
    cheque_deposit: '支票存款',
    fps_deposit: 'FPS转数快',
    sub_account_deposit: '子账户存款',
    noDeposit: '无存款记录'
  },
  steps: {
    step_one: '步骤1',
    step_two: '步骤2',
    step_three: '步骤3',
    step_four: '步骤4',
    step_five: '步骤5',
    // 网上银行转账
    online_stepCon_one: '登陆个人网上银行网页或APP',
    online_stepCon_two: '选择转账服务',
    online_stepCon_three: '正确填写及检查转账申请资料:</br>',
    online_stepCon_four:
      '确认转账申请并截图保存已成功转账确认页面作为汇款凭证 – 必需清楚显示以下资料:',
    online_stepCon_four_list: [
      'a.存款日期',
      'b.存款金额',
      'c.支账银行名称及账户',
      'd.入账银行名称及账户',
      'e.转账确认编号'
    ],
    online_stepCon_five: '提交存款申请并上传汇款凭证',
    // ATM 转账
    atm_stepCon_one: '登陆ATM自动柜员机',
    atm_stepCon_two: '使用转账服务',
    atm_stepCon_three: '提供正确及检查转账申请资料:</br>',
    atm_stepCon_four: '必须取得转账单据作为汇款凭证– 必需清楚显示以下资料:',
    atm_stepCon_four_list: [
      'a.存款日期',
      'b.存款金额',
      'c.支账银行名称及账户',
      'd.入账银行名称及账户',
      'e.转账确认编号'
    ],
    atm_stepCon_five: '提交存款申请并上传汇款凭证',
    // 银行转账
    counter_stepCon_one: '前往银行柜台进行汇款申请',
    counter_stepCon_two:
      '申请汇款至艾德证券期货有限公司的指定银行账户 (不接受存入现金, 请由客户的个人银行账户转账至艾德证券期货)</br>',
    counter_stepCon_three:
      '取得汇款凭证，请确保收据上清楚显示存入的金额、日期、汇款人及收款人资料',
    counter_stepCon_four: '提交存款申请并上传汇款凭证',
    // 支票存款
    cheque_stepCon_one:
      '支票抬头请填写「艾德证券期货有限公司」 或 “Eddid Securities and Futures Limited”',
    cheque_stepCon_two:
      '存入支票前先复印或拍摄支票作为汇款凭证，请确保复印本上已清楚显示银行账户持有人姓名及账号',
    cheque_stepCon_three:
      '往银行柜台或「存支票机」存入支票，向银行提供艾德证券期货有限公司的银行资料',
    cheque_stepCon_four:
      '取得支票存款收据作为汇款凭证，请确保收据上清楚显示存入的金额、日期及支票号码(若以「存支票机」存入支票，请先将收据放大复印及调深颜色，以便核对支票上的银行资料。)',
    cheque_stepCon_five:
      '提交存款申请并上传汇款凭证，请详阅<a href="https://www.eddidsfl.com/zijin/?ss_menu_cn=%E6%B8%AF%E7%BE%8E%E8%82%A1%E5%8F%8A%E5%9F%BA%E9%87%91%E8%B5%84%E9%87%91%E5%AD%98%E5%85%A5%E5%8F%8A%E6%8F%90%E5%8F%96&ss_menu_name=zj_gmgsfbz" target="_blank">「支票存款注意事项」</a>',
    // FPS-转数快
    FPS_stepCon_one:
      '以转数快（FPS）转账至艾德FPS识别码：</br>证券:100067040(HSBC汇丰银行)</br>期货:165544362(HSBC汇丰银行)</br>基金:100067040(HSBC汇丰银行)',
    FPS_stepCon_two:
      '将交易纪录截屏存档（需清楚显示<span style="color: #EF6917;">‌客户银行帐户号码</span>‌及<span style="color: #EF6917;">汇款日期</span>‌）',
    FPS_stepCon_three: '提交存款申请并上传存款凭证',
    // 子账户存款
    subAccount_stepCon_one: '登陆个人网上银行网页或APP',
    subAccount_stepCon_two: '选择转账服务',
    subAccount_stepCon_three: '正确填写子账户资料',
    subAccount_stepCon_four:
      '确认转账申请并截图保存已成功转账确认页面作为汇款凭证 – 必需清楚显示以下资料:</br>' +
      'a.存款日期</br>' +
      'b.存款金额</br>' +
      'c.支账银行名称及账户</br>' +
      'd.入账银行名称及账户</br>' +
      'e.转账确认编号',
    subAccount_stepCon_five: '提交存款申请并上传汇款凭证'
  },
  note:
     `1. 7×24 小时存款服务：包括 eDDA 存款、符合 FPS 7×24 存款指引的存款、使用已完成认证的登记银行或指定银行账户存款至艾德证券期货有限公司（「本公司」）汇丰账户的港币存款。<br />
      2. 除上述 7×24 小时存款服务外，其余存款办理时间如下：客户于星期一至五（香港公众假期、圣诞前夕、除夕及农历新年前夕除外）15:00 前存入资金并提交存款证明，存款将于当天办理完成；其后收到的存款申请，将于下一个工作日处理。<br />
      3. 本公司无法保证所有7×24小时存款申请均能实时完成。未能实时完成办理的存款申请，将于工作日办公时间内由专人跟进处理。<br />
      4、结单显示规则 <br />
      （以下均为香港时间）<br />
      <span style="color:#333;font-weight:500;">(I) 证券/基金账户：</span>客户于每日16:59或之前办理完成的存款将反映在当日的结单；其后完成的存款将显示在下一交易日的结单。<br />
      <span style="color:#333;font-weight:500;">(II) 期货账户：</span><br />
      <span style="color:#333;font-weight:500;">美东夏令时间：</span><br />
      客户于星期一至五（元旦除外）05:00至翌日04:59期间办理完成的存款将反映在当日的结单；于星期六04:59后办理完成的存款将显示在下一交易日的结单。<br />
      <span style="color:#333;font-weight:500;">美东冬令时间：</span><br />
      客户于星期一至五（元旦除外）06:00至翌日05:59期间办理完成的存款将反映在当日的结单；于星期六05:59后办理完成的存款将显示在下一交易日的结单。<br />
      备注：若存款于每年元旦当日办理完成，相关记录将显示在下一交易日的结单。<br />
      <span style="color:#333;font-weight:500;">(III) 杠杆式外汇账户：</span><br />
      <span style="color:#333;font-weight:500;">美东夏令时间：</span><br />
      客户于星期一至五05:05至翌日04:55期间办理完成的存款将反映在当日的结单；于星期六04:55后办理完成的存款将显示在下一交易日的结单。 <br />
      <span style="color:#333;font-weight:500;">美东冬令时间：</span> <br />
      客户于星期一至星期五当日06:05至翌日05:55期间办理完成的存款将反映在当日的结单；于星期六05:55后办理完成的存款将显示在下一交易日的结单。 <br />
      5. 本公司不接受第三者转账或存款，银行账户持有人或汇款人的姓名必须与本公司账户持有人的姓名相同。如客户从未提供该汇款银行账户之银行证明，请附上有关银行账户证明，如银行月结单、提款卡、银行存折首页复印本等，该等证明档必须清楚显示账户持有人的姓名及银行账号以核对存款者身份。 <br />
      6. 如存款涉及特快转账(CHATS)、电汇及本地银行非港币的转账，汇出银行、中转银行和收款银行有可能收取相应的手续费，具体费用请以银行实际收取为准。 <br />
      7. 本公司不接受任何现金存款，如客户欲存入现金，请先将现金存入银行账户，再由客户的银行账户转账至本公司之银行账户。 <br />
      8. 本公司不能保证接收或处理现金存款或来自任何第三者之款项。 <br />
      9. 客户存款时请填写正确的账户名称，填写错误将导致汇款被银行退回或产生费用，本公司概不负责。 <br />
      10. 如有任何查询，请致电+852 2655 0338 / 400 120 0068（中国内地免费热线） 或电邮 cs@eddidsec.com与本公司联络`,
  chequeNote:
    '<div style="color:#333;font-weight:500;margin-bottom:5px">存入资金前, 请详阅存入资金注意事项：</div>' +
    '1、存款处理时间为香港时间星期一至五上午九时至下午三时（香港公众假期除外）。如我们在以上时间内收到您的资金及存款证明，存款将于一个工作天内存入您的交易账户。 </br>' +
    '2、所有于下午三时后收到的款项及存款收据，将于下一个工作天处理。 </br>' +
    '3、相同银行转账豁免手续费；经跨行转账，阁下银行有可能征收手续费。 </br>' +
    '4、艾德证券期货有限公司不接受第三者转账或存款，银行账户持有人或汇款人的姓名必须与艾德证券账户持有人的姓名相同。</br>' +
    '5、艾德证券不接受任何现金存款，如您持有现金，请先将现金存入您的银行账户，再由阁下的银行账户转账至艾德证券的银行账户。</br>' +
    '6、艾德证券不能保证接收、处理或退回现金存款或来自任何第三者之款项。</br>' +
    '7、艾德证券保留将资金退回存款来源的权利，及艾德证券不保证某些提款选项。</br>' +
    '8、如欲索取进一步资料，请致电+852 2655 0338 / 400 120 0068（中国内地免费热线） 或电邮 cs@eddidsec.com 与艾德证券联络。</br>' +
    '9、汇款时请填写正确的账户名称，填写错误将导致汇款被银行退回，因此产生的费用将由阁下自行承担。</br>' +
    '<div style="color:#333;font-weight:500;padding-top:10px;margin-bottom:5px">反洗钱警告：</div>' +
    '如客户的交易账户在存款后没有进行正常交易活动后作出提款申请，已有可能涉及洗钱活动。艾德证券期货有可能将账户停用或取消。',
  note_FPS:
    '<div style="color:#333;font-weight:500;margin-bottom:5px">存入资金前, 请详阅存入资金注意事项：</div>' +
    '1、存款处理时间： 如阁下于星期一至五（香港公众假期、圣诞前夕、除夕及农历新年前夕除外）下午3时前存入资金并提交存款证明，存款将于当天办理完成；其他时间收到之存款申请将于下一个工作天处理。</br>' +
    '2、不接受第三者转帐或存款，银行帐户持有人或汇款人的姓名必须与艾德证券帐户持有人的姓名相同。如未曾提供该汇款银行帐户银行证明，请附上有关银行帐户证明文件，如银行月结单、提款卡、银行存折首页复印本等，该等文件必须清楚显示帐户持有人的姓名及银行帐号以核对存款者身份。</br>' +
    '3、艾德证券期货不能保证接收、处理或退回现金存款或来自任何第三者之款项。</br>' +
    '4、艾德证券期货保留将资金退回存款来源的权利，并且不保证某些提款选项。</br>' +
    '5、如有任何查询，请致电+852 2655 0338 / 400 120 0068（中国内地免费热线） 或电邮 cs@eddidsec.com 与我们联络。</br>' +
    '6、汇款时请填写正确的账户名称，填写错误将导致汇款被银行退回，因此产生的费用将由阁下自行承担。</br>' +
    '<div style="color:#333;font-weight:500;padding-top:10px;margin-bottom:5px">反洗钱警告：</div>' +
    '如客户的交易账户在存款后没有进行正常交易活动后作出提款申请，已有可能涉及洗钱活动。艾德证券期货有可能将账户停用或取消。',
  type: {
    notice: '请阅读存款注意事项，并按以下流程办理汇款申请。',
    up_button: '上传存款收据'
  },
  upload: {
    please_sel: '请选择',
    account_number: '交易账号',
    bank_card_number: '汇款银行账号',
    deposit_amount: '存款金额',
    eddid_bank: '艾德收款账号',
    upload_transfer_voucher: '上传转账凭证',
    upload_bank_proof: '上传银行证明',
    submit: '提交',
    please_input: '请输入存款金额',
    please_input_other_bank_name: '请输入其他银行名称',
    please_input_other_bank_card: '请输入其他银行账号',
    please_input_correct_bank_card: '请输入正确的银行卡号',
    other_bank_name: '其他银行名称',
    other_bank_card: '其他银行账号',
    back_card_verify: '请选择一个银行账号',
    remittance_amount_verify: '请填写正确的汇款金额',
    eddid_account_verify: '请选择艾德账户',
    upload_image_verify_isNull: '请上传存款证明',
    upload_bank_verify_isNull: '请上传银行证明',
    upload_image_verify_size: '上传图片不能超过5M',
    upload_image_verify_type: '仅接受JPG，PNG，PDF，JPEG格式',
    haveRead: '本人已阅读，知悉及明白「存款相关费用明细」',
    depositTipsTitle: '存款相关费用明细',
    depositTips: {
      wireTransfer: {
        title: '电汇费用 (银行收取)',
        tips:
          '如客户以非本地银行户口以电汇方式存款到公司的本地银行户口, 银行有可能收取电汇费用, 视乎有关银行的政策而订。客户需向其汇款银行查询。'
      },
      other: {
        title: '其他收费 (银行收取)',
        tips:
          '银行有可能收费行政费用, 视乎有关银行的政策而订。客户需向其汇款银行查询。'
      },
      exchangePriceDifferenceBank: {
        title: '兑换差价 (银行收取)',
        tips:
          '如客户存款货币与本公司的银行户口货币不同, 当中可能产生兑换差价。',
        example:
          '如:客户存入人民币到本公司的美元银行户口，银行会以其汇率兑换客户之人民币至美元，当中可能产生兑换差价。客户需向其汇款银行查询。'
      },
      exchangePriceDifferenceCompany: {
        title: '兑换差价 (本公司收取)',
        tips:
          '如客户存款货币与其交易账户结算货币不同,本公司会以本公司适用的银行汇率兑换其存款为交易账户结算货币后进行存款, 过程中有可能产生兑换差价。',
        example:
          '如: 客户交易账户以美元作为结算货币，所有港元/人民币存款将会以本公司适用的银行汇率兑换成美元显示于您的交易账户内。'
      }
    }
  },
  dialog: {
    success: '您的存款申请已成功提交，如有问题请与我们联系',
    title: '您的申请编号是',
    prompt: '我们会尽快处理你的申请，',
    button: '确定'
  },
  bankAccount: {
    eddid_bank_account: '艾德银行账户',
    FPS_code: '艾德转数快识别码'
  },
  depositWay: {
    online_bank_deposit: 'ONLINE BANK DEPOSIT'
  },
  saveHK: '存入港币',
  saveUSD: '存入美元',
  saveRMB: '存入人民币',
  payee_number: '收款人账户号码',
  account_name: '账户名称',
  bank_number: '银行卡号',
  payee_name: '收款人姓名',
  swift_code: 'SWIFT 代码',
  bank_address: '收款人银行地址',
  identifier: '识别码',
  HKD: '港币',
  USD: '美元',
  CNY: '人民币',
  receiveBankName: '收款银行',
  bankCode: '银行编号',
  receiveName: '收款人名称',
  beneficiaryAccount: '收款人账户',
  fpsInfo:
    '通过FPS存款时，请务必于客户汇款银行FPS转账界面备注栏填写客户于艾德证券期货的交易账户号码，否则会影响客户的存款到账。',
  hsbcInfo:
    '另外，客户通过FPS存款至艾德证券期货HSBC FPS收款账户，只需于客户汇款银行完成FPS转账即可，无需在此处上传凭证，我们收到客户的存款后会通过邮件通知客户。',
  fpsnum: '转账识别码',
  fpsWarn:
    '请于FPS转账页面中「致收款人信息」栏内填入此号码',
  othertext: '其他银行',
  edAccNum: '艾德交易账户号码',
  requirements_deposit: '为符合监管机构要求，客户如欲使用新绑定之银行账户或其他未绑定之银行账户存款，则其首次存款数额不可少于10,000港元或等值的货币，否则艾德证券期货有机会未能处理阁下的存款。',
  requirements_account: '为符合监管机构要求，客户如欲使用其他未绑定之银行账户存款，则其首次存款数额不可少于10,000港元或等值的货币，否则艾德证券期货有机会未能处理阁下的存款。',
  requirements_bank: '为符合监管机构要求，客户如欲使用其他新绑定之银行账户存款，则其首次存款数额不可少于10,000港元或等值的货币，否则艾德证券期货有机会未能处理阁下的存款。',
  fpsDepositProcess: `<div style="color:#333;font-weight:500;margin-bottom:5px">转数快（FPS）存款流程</div>
    <div style="color:#333;font-weight:500;margin-bottom:5px">如透过转数快转账至汇丰银行，请于FPS转账页面「致收款人信息」栏填写艾德交易账户号码。如没有填写，请致电客户服务热线 +852 2655 0338 / 400 120 0068（中国内地免费热线）与我们确认款项。</div>
    <div style="color:#333;font-weight:500;margin-bottom:5px">1. [证券或基金]</div>
    转数快识别码：100067040 </br>
    收款銀行：汇丰银行 HSBC </br>
    收款人名稱: EDDID SECURITIES AND FUTURES LTD – CLIENTS ACCOUNT-SECURITIES(FPS) </br>
    <div style="color:#333;font-weight:500;margin-bottom:5px">2. [期货]</div>
    转数快识别码：165544362 </br>
    收款銀行：汇丰银行 HSBC </br>
    收款人名稱: EDDID SECURITIES AND FUTURES LIMITED - CLIENTS' ACCOUNT (FUTURES) (HKFE Trade) (FPS)`
}
